import { Documents } from "@/components/documents/Documents.tsx";
import { EmployeePageComponentProps } from "@/pages/employees/employee/components/employee-page-components.types.ts";
import { useEmployeeDocumentsFolders } from "@/queries/employees/use-employee-documents.query.ts";
import { useDocumentFoldersList } from "@/queries/use-documents.query.ts";
import { ApiFolderType, folderParamKeys } from "@/types/document.types.ts";
import { useSearchParams } from "react-router-dom";

export const EmployeeDocuments = ({ employee }: EmployeePageComponentProps) => {
  const [searchParams] = useSearchParams();
  const hasOpenEmployeeFolder = searchParams.has(folderParamKeys[ApiFolderType.employee]);
  const hasOpenOrgFolder = searchParams.has(folderParamKeys[ApiFolderType.organization]);

  const { data: employeeFolders, isLoading: isEmployeeFoldersLoading } =
    useEmployeeDocumentsFolders(employee.id);
  const { data: orgFolders, isLoading: isOrgFoldersLoading } = useDocumentFoldersList(
    ApiFolderType.organization
  );

  return (
    <>
      {!hasOpenOrgFolder && (
        <Documents
          folders={employeeFolders || []}
          isLoading={isEmployeeFoldersLoading}
          foldersType={ApiFolderType.employee}
          employee={employee}
        />
      )}

      {!hasOpenEmployeeFolder && (isOrgFoldersLoading || (orgFolders && orgFolders.length > 0)) && (
        <Documents
          folders={orgFolders || []}
          isLoading={isOrgFoldersLoading}
          foldersType={ApiFolderType.organization}
        />
      )}
    </>
  );
};
